var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import { DeliveryRequestIcon } from '../../atoms/Icons';
import { Fab, Zoom, useTheme } from '@mui/material';
import MaterialTable from '../../MaterialTable';
import { decamelize } from '../../../utils/camelize';
import { getAll } from '../../../api/warehouseItem';
import { useWarehouseItemColumns } from '../../../hooks/useColumns';
import { useRequest } from '../../../hooks/requestHook';
import DeliveryRequestsNewForm from '../RoasterWarehouseItemsPage/DeliveryRequestsNewForm';
import qs from 'qs';
import useFetch from '../../../hooks/useFetch';
import { useRoaster } from '../../../hooks/useRoaster';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var RoasterWarehouseItems = function (_a) {
    var roasterId = _a.roasterId;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var location = useLocation();
    var theme = useTheme();
    var WarehouseItemColumns = useWarehouseItemColumns({ role: 'admin' });
    var getAllApi = useRequest(getAll);
    var _b = React.useState(false), openDialog = _b[0], setOpenDialog = _b[1];
    var _c = React.useState([]), selectedItems = _c[0], setSelectedItems = _c[1];
    var roaster = useRoaster(roasterId).roaster;
    var urlQuery = React.useMemo(function () { return qs.parse(location.search.slice(1)); }, [location.search]);
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        if (field === 'requestableQuantity' &&
            Object.keys(urlQuery).length === 0) {
            return 'inStock';
        }
        return filters[field];
    }, [urlQuery]);
    var handleSelectionChange = React.useCallback(function (_, rowData) {
        if (!rowData)
            return;
        var row = rowData;
        if (row.tableData.checked) {
            setSelectedItems(__spreadArray([row], selectedItems, true));
        }
        else {
            setSelectedItems(selectedItems.filter(function (item) { return row.id != item.id; }));
        }
    }, [selectedItems]);
    var handleOpenDialog = React.useCallback(function () { return setOpenDialog(true); }, []);
    var handleCloseDialog = React.useCallback(function () { return setOpenDialog(false); }, []);
    var handleRequested = React.useCallback(function () {
        setSelectedItems([]);
        setOpenDialog(false);
        navigate("/admin/delivery_requests");
    }, [navigate]);
    var selectionProps = React.useCallback(function (row) {
        return {
            size: 'medium',
            disabled: row.requestableQuantity <= 0,
            checked: selectedItems.map(function (item) { return item.id; }).includes(row.id),
        };
    }, [selectedItems]);
    var columns = React.useMemo(function () { return [
        WarehouseItemColumns.offerListLink,
        __assign(__assign({}, WarehouseItemColumns.orderLink), { filtering: false }),
        __assign(__assign({}, WarehouseItemColumns.lotNumber), { defaultFilter: defaultFilter('offer.lotNumber'), cellStyle: {
                width: 50,
            } }),
        __assign(__assign({}, WarehouseItemColumns.isTypicaSelection), { filtering: false }),
        __assign(__assign({}, WarehouseItemColumns.requestableQuantity), { title: t('pages.roasterWarehouseItems.requestable'), filtering: true, defaultFilter: defaultFilter('requestableQuantity') }),
        __assign(__assign({}, WarehouseItemColumns.deliveringQuantity), { filtering: false, title: t('pages.roasterWarehouseItems.delivering') }),
        __assign(__assign({}, WarehouseItemColumns.deliveredQuantity), { filtering: false, title: t('pages.roasterWarehouseItems.delivered') }),
        __assign(__assign({}, WarehouseItemColumns.endOfStoragePeriod), { filtering: false }),
    ]; }, [t, WarehouseItemColumns, defaultFilter]);
    var buildFilterParams = React.useCallback(function (query) {
        if (!roaster)
            return {};
        var q = {};
        q['order_roaster_id_eq'] = roaster.id;
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'requestableQuantity':
                    if (filter.value == 'inStock')
                        q.requestable = true;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, [roaster]);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            case 'offer.lotNumber':
                return 'offers.lot_number';
            default:
                return decamelize(order);
        }
    }, []);
    var fetchWarehouseItems = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAllApi,
        buildOrder: buildOrder,
    });
    if (!roaster)
        return null;
    return (React.createElement(Wrapper, null,
        React.createElement(MaterialTable, { title: t('pages.warehouseItems.title'), model: "warehouseItem", columns: columns, data: fetchWarehouseItems, onSelectionChange: handleSelectionChange, options: {
                selection: true,
                selectionProps: selectionProps,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                filtering: true,
                paging: !openDialog,
                initialPage: initialPage,
                pageSize: pageSize,
            } }),
        React.createElement(FullScreenDialog, { title: t('pages.warehouseItems.deliveryRequest'), open: openDialog, onClose: handleCloseDialog }, selectedItems.length > 0 && (React.createElement(DeliveryRequestsNewForm, { roaster: roaster, warehouseItems: selectedItems, onSuccess: handleRequested, isAdmin: true }))),
        React.createElement(Zoom, { in: selectedItems.length > 0, timeout: {
                enter: theme.transitions.duration.enteringScreen,
                exit: theme.transitions.duration.leavingScreen,
            }, style: {
                transitionDelay: "".concat(theme.transitions.duration.leavingScreen, "ms"),
                position: 'fixed',
                bottom: 30,
                right: 30,
            }, unmountOnExit: true },
            React.createElement(Fab, { onClick: handleOpenDialog, color: "primary" },
                React.createElement(DeliveryRequestIcon, null)))));
};
export default RoasterWarehouseItems;
var templateObject_1;
